module.exports = __webpack_public_path__ + "img/joinStraight2.0904c03b.svg";